import { type } from 'arktype';

import { FiatAccountType } from '@/types/fiatAccountType';
import { PaymentMethodAccountType } from '@/types/paymentMethodAccountType';

export enum CryptoNetworkType {
  ETH = 'ETH',
  TRON = 'TRON',
}

export const cryptoPaymentMethodSchema = type({
  type: type.enumerated(PaymentMethodAccountType.crypto),
  paymentMethod: type.enumerated(FiatAccountType.crypto),
  network: type.valueOf(CryptoNetworkType).configure({ message: 'VALIDATION_REQUIRED' }),
  walletAddress: type('string > 0').configure({ message: 'VALIDATION_REQUIRED' }),
  vaspId: 'string',
  vaspName: 'string',
  isNonCustodialWallet: 'boolean',
}).readonly();

export type CryptoPaymentForm = typeof cryptoPaymentMethodSchema.infer;

export const isCryptoPaymentForm = (value: unknown): value is CryptoPaymentForm =>
  cryptoPaymentMethodSchema.allows(value);
